// Item (e), batch 3: the "Sent Follow-up Emails" report.

const pad = n => String(n).padStart(2, '0')
const day = d => (d instanceof Date && !isNaN(d.getTime()) ? pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear() : null)

/** The filter form as the request body: empty fields are left out; dates as dd/MM/yyyy. */
export function sentFilterBody(form, page, size) {
  var f = form || {}
  var out = { page: page || 0, size: size || 50 }
  var from = day(f.from)
  var to = day(f.to)
  if (from) out.from = from
  if (to) out.to = to
  ;['customer', 'contact', 'quoteNo'].forEach(k => {
    var v = (f[k] || '').trim()
    if (v) out[k] = v
  })
  if (f.userId !== null && f.userId !== undefined) out.userId = f.userId
  return out
}

/** "Sent to x (meant for y)" when TEST redirected it, else "Sent to x". */
export function sentTo(row) {
  if (!row) return ''
  var to = row.actualTo || ''
  var meant = row.intendedTo || ''
  return meant && to && meant.toLowerCase() !== to.toLowerCase() ? to + ' (meant for ' + meant + ')' : to
}

/** The Follow up page (04/10/2026): the list's Global Search and sorted column, added to the filter body. */
export function sentListBody(form, page, size, { search, sortField, sortOrder } = {}) {
  var out = sentFilterBody(form, page, size)
  var s = String(search || '').trim()
  if (s) out.search = s
  if (sortField && sortOrder) {
    out.sortField = sortField
    out.sortOrder = sortOrder > 0 ? 1 : -1
  }
  return out
}

/** The "meant for" part of a TEST-redirected address, shown on its own line; '' otherwise. */
export function meantFor(row) {
  if (!row) return ''
  var to = row.actualTo || ''
  var meant = row.intendedTo || ''
  return meant && to && meant.toLowerCase() !== to.toLowerCase() ? meant : ''
}
